<template>
  <v-content class="z-app-content-light">
    <iframe width="100%" height="600px" src="/api/index.html"></iframe>
  </v-content>
</template>

<script>
// import VueFriendlyIframe from "vue-friendly-iframe";

export default {
  name: "ApiPage",
  // components: { VueFriendlyIframe },
  data: () => ({
    apidoc: "Loading...",
  }),
};
</script>
